import { PluginSlot } from '@openedx/frontend-plugin-framework';
import { SearchField } from '@openedx/paragon';
import { useIntl } from '@edx/frontend-platform/i18n';
import { getConfig } from '@edx/frontend-platform';

import messages from '@src/catalog/messages';
import type { CourseCatalogSearchFieldSlotProps } from './types';

const CourseCatalogSearchFieldSlot = ({
  setSearchInput,
  handleSearch,
  initialSearchValue,
}: CourseCatalogSearchFieldSlotProps) => {
  const intl = useIntl();

  return (
    <PluginSlot
      id="org.openedx.frontend.catalog.course_catalog_page.search_field"
      slotOptions={{
        mergeProps: true,
      }}
      pluginProps={{
        setSearchInput,
        handleSearch,
        initialSearchValue,
      }}
    >
      {getConfig().ENABLE_COURSE_DISCOVERY && (
        <div className="catalog-page__search-shell">
          <SearchField
            key="search-field"
            className="catalog-page__search-field"
            placeholder={intl.formatMessage(messages.searchPlaceholder)}
            onChange={(value: string) => {
              setSearchInput(value);
            }}
            onSubmit={(value: string) => {
              setSearchInput(value);
              handleSearch(value);
            }}
            value={initialSearchValue}
          />
        </div>
      )}
    </PluginSlot>
  );
};

export default CourseCatalogSearchFieldSlot;
